import React from 'react'

import { Drawer } from 'antd'

import './drawerInside.scss';

interface DrawerInsideProperties{
    showadd: boolean,
    dOnClose: any,
    children: React.ReactNode
    dTitle: any,
    dwidth?: string | number
    mobilefixed: boolean,
    style?: any
    innercontainer?: 'no-inner' | undefined
    placement?: "top" | "right" | "bottom" | "left" | undefined
}

const DrawerInsideComponent = (props : DrawerInsideProperties) : JSX.Element | any => {

    return (
        <Drawer placement={props.placement ? props.placement : 'left'}
            title={props.dTitle}
            style={{...props.style, position:"absolute", maxHeight: "100vh"}}
            className={props.mobilefixed?'mobile-fixed':''}
            footer={<><span>¿Acaso hay algo más sencillo? Si tienes alguna duda escribe a <a href='mailto:we.love@omnicode.es'>we.love@omnicode.es</a></span></>}
            closable={true}
            onClose={props.dOnClose}
            getContainer={ props.innercontainer === 'no-inner' ? undefined : false }
            visible={props.showadd}
            width={ props.dwidth || "100%"}
            {...props}>
            {props.children}
        </Drawer>
    )
}

export default DrawerInsideComponent;